import { gql } from 'react-apollo';

export default gql`
  mutation updateInvestorOfferViews($offerId: ID!) {
    updateInvestorOfferViews(offerId: $offerId)
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/updateInvestorOfferViews.js